
export class UpdateClaimItemCommentModel {
  ARClaimItemID: string;
  Comment: string;
}
